import {useState} from 'react';

import {ElementMouseEvent} from 'util/Types';

export const DEFAULT_SIDEBAR_WIDTH = 350;
export const MINIMUM_SIDEBAR_WIDTH = 250;

type SidebarDragState = {
  startSidebarWidth: number;
} & ({resizing: true; startMouseX: number} | {resizing: false});

interface SidebarDragStateOutput {
  sidebarWidth: number;
  resizing: boolean;
  startSidebarResize: (e: ElementMouseEvent) => void;
  sidebarResize: (e: ElementMouseEvent) => void;
  endSidebarResize: (e: ElementMouseEvent) => void;
}

export default function useSidebarDragState(): SidebarDragStateOutput {
  const [sidebarWidth, setSidebarWidth] = useState(DEFAULT_SIDEBAR_WIDTH);
  const [sidebarDragState, setSidebarDragState] = useState<SidebarDragState>({
    resizing: false,
    startSidebarWidth: DEFAULT_SIDEBAR_WIDTH,
  });
  return {
    sidebarWidth,
    resizing: sidebarDragState.resizing,
    startSidebarResize: (e: ElementMouseEvent): void => {
      if (sidebarDragState.resizing) {
        return;
      }
      setSidebarDragState({
        resizing: true,
        startMouseX: e.clientX,
        startSidebarWidth: sidebarWidth,
      });
      e.preventDefault();
    },
    sidebarResize: (e: ElementMouseEvent): void => {
      if (!sidebarDragState.resizing) {
        return;
      }

      const mouseDeltaX = Math.floor(e.clientX - sidebarDragState.startMouseX);
      setSidebarWidth(Math.max(MINIMUM_SIDEBAR_WIDTH, sidebarDragState.startSidebarWidth - mouseDeltaX));
      e.preventDefault();
    },
    endSidebarResize: (e: ElementMouseEvent): void => {
      if (!sidebarDragState.resizing) {
        return;
      }
      setSidebarDragState({resizing: false, startSidebarWidth: sidebarWidth});
      e.preventDefault();
    },
  };
}
